"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateInput = void 0;
const SendButton_1 = require("../buttons/SendButton");
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const DateInput = ({ onSubmit, isRange, isRequired, labels, hasTime, }) => {
    var _a, _b;
    const { t } = (0, react_i18next_1.useTranslation)();
    const [inputValues, setInputValues] = (0, react_1.useState)({ from: "", to: "" });
    return (react_1.default.createElement("div", { className: "flex flex-col w-full lg:w-4/6" },
        react_1.default.createElement("div", { className: "flex items-center" },
            react_1.default.createElement("form", { className: "flex justify-between rounded-lg typebot-input " +
                    (isRange ? "flex-col" : "items-center"), onSubmit: (e) => {
                    if (isRequired && inputValues.from === "" && inputValues.to === "")
                        return;
                    e.preventDefault();
                    onSubmit(`${inputValues.from}${isRange ? ` to ${inputValues.to}` : ""}`);
                } },
                react_1.default.createElement("div", { className: "flex items-center px-4 py-4" },
                    isRange && (react_1.default.createElement("p", { className: "font-semibold mr-2" }, (_a = labels === null || labels === void 0 ? void 0 : labels.from) !== null && _a !== void 0 ? _a : t("from"))),
                    react_1.default.createElement("input", { className: "focus:outline-none bg-transparent flex-1 w-full comp-input", type: hasTime ? "datetime-local" : "date", onChange: (e) => setInputValues(Object.assign(Object.assign({}, inputValues), { from: e.target.value })) })),
                isRange && (react_1.default.createElement("div", { className: "flex items-center pl-4 pr-2 pb-2" },
                    isRange && (react_1.default.createElement("p", { className: "font-semibold" }, (_b = labels === null || labels === void 0 ? void 0 : labels.to) !== null && _b !== void 0 ? _b : t("to"))),
                    react_1.default.createElement("input", { className: "focus:outline-none bg-transparent flex-1 w-full comp-input ml-2", type: hasTime ? "datetime-local" : "date", onChange: (e) => setInputValues(Object.assign(Object.assign({}, inputValues), { to: e.target.value })) }),
                    react_1.default.createElement(SendButton_1.SendButton, { label: labels === null || labels === void 0 ? void 0 : labels.button, isDisabled: (isRequired !== null && isRequired !== void 0 ? isRequired : true) &&
                            inputValues.to === "" &&
                            inputValues.from === "", className: "ml-4" }))),
                !isRange && (react_1.default.createElement(SendButton_1.SendButton, { label: labels === null || labels === void 0 ? void 0 : labels.button, isDisabled: (isRequired !== null && isRequired !== void 0 ? isRequired : true) && inputValues.from === "", className: "ml-4 mr-2" }))))));
};
exports.DateInput = DateInput;
//# sourceMappingURL=DateInput.js.map